import { AppConfig } from '@core/domain/AppConfig.ts';
import type { GetSqlJsDatabase } from '@src/modules/platform/local-sqlite/domain/GetSqlJsDatabase.ts';
import { searchBeneficiariosWithRemoteCache } from './beneficiarioSearchUseCases.ts';

export type FeatureBeneficiarioSearchDeps = {
  getDb?: GetSqlJsDatabase;
  getToken?: () => string | null;
  markDirty?: () => void;
};

export function searchBeneficiariosForFeature<
  T extends { publicId: string; documento: string; nombre: string },
>(
  query: string,
  searchLocal: (q: string) => Promise<T[]>,
  deps: FeatureBeneficiarioSearchDeps,
): Promise<T[]> {
  return searchBeneficiariosWithRemoteCache({
    query,
    searchLocal: () => searchLocal(query),
    getDb: deps.getDb ?? (() => undefined),
    getToken: deps.getToken ?? (() => null),
    apiBaseUrl: AppConfig.getSyncApiBaseUrl(),
    markDirty: deps.markDirty,
  });
}
